<mat-card appearance="outlined" class='legal-entity-mat-card'>
  <mat-card-header class='legal-entity-mat-card-header'>
    <mat-card-title>
      <mat-icon>business</mat-icon>
      {{ legalEntity.legalName }} - {{ legalEntity.legalEntityNumber}}
    </mat-card-title>
    <mat-card-subtitle>
      {{ 'company.formState.status.' + (formState$ | async) | translate}}
    </mat-card-subtitle>

  </mat-card-header>
  <mat-card-content class="action-button-container">
    @if ((isFormCompleted$ | async)) {
      <div>
        <button
          mat-flat-button
          (click)="getPdf()"
          color="primary"
          [disabled]="isSummaryDownloading"
          >
          <mat-icon>picture_as_pdf</mat-icon>
          {{ 'annualDeclaration.downloadSummary' | translate }}
        </button>
        @if (legalEntityInvoices?.length>0) {
          <button class="receipt-button" title="Reçus"
            mat-raised-button
            [matMenuTriggerFor]="menu">
            <mat-icon>receipt_long</mat-icon>
            {{legalEntityInvoices?.length }} Reçus
          </button>
        }
        <div>
          <mat-menu #menu="matMenu">
            @for (inv of legalEntityInvoices; track inv) {
              <button mat-menu-item  (click)="showInvoice(inv)">
                <span>{{inv.description}}</span>
              </button>
            }
          </mat-menu>
          @if (legalEntityInvoices === null || legalEntityInvoices === undefined) {
            <mat-spinner class="button-spinner"
              diameter="30">
            </mat-spinner>
          }
        </div>
      </div>
    }
    @if (year$ | async; as year) {
      <div class="action-button-container">
        @if (!(isRecentlyCreatedLegalEntity$ | async)) {
          <div>
            @if (isFormEditable$ | async) {
              <button class="action-button" mat-flat-button (click)="goToForm()" color="primary">
                {{'annualDeclaration.fillForm' | translate }} {{ year }}
              </button>
            }
          </div>
        }
        @if (isRecentlyCreatedLegalEntity | async) {
          <div>
            {{ 'annualDeclaration.noNeedToFillForm' | translate : { year: year } }}
          </div>
        }
      </div>
    }
  </mat-card-content>
</mat-card>
